import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import HowItWorks from "@/components/HowItWorks";
import Showcase from "@/components/Showcase";
import PrizeGrid from "@/components/PrizeGrid";
import Testimonials from "@/components/Testimonials";
import RebateSection from "@/components/RebateSection";
import ClosingCta from "@/components/ClosingCta";
import Footer from "@/components/Footer";
import StickyBar from "@/components/StickyBar";

export default function Landing() {
  return (
    <div className="grain relative min-h-screen overflow-x-clip bg-background text-foreground md:pb-0">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <HowItWorks />
        <Showcase />
        <PrizeGrid />
        <Testimonials />
        <RebateSection />
        <ClosingCta />
      </main>
      <Footer />
      {/* Spacer so the mobile sticky bar never covers the footer */}
      <div className="h-[72px] md:hidden" />
      <StickyBar />
    </div>
  );
}
